jQuery_T4NT(document).ready(function($) {

     /**
     *  Variant selection changed
     *  data-variant-toggle="{{ variant.id }}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

//switchSwatchPdp()
  
});
/*
function switchSwatchPdp() {
   document.querySelectorAll('.t4s-form__product .t4s-swatch__list .t4s-swatch__item').forEach(item => {
    item.addEventListener('click', function () {
      console.log(item)
        // Leer el valor de data-value
        const dataValue = this.getAttribute('data-value');

        // Extraer únicamente los números del valor
        const match = dataValue.match(/\d+/);
        const number = match ? match[0] : null;

        if (number) {
            // Seleccionar todos los elementos con la clase "dis-standard-*" y ocultarlos
            document.querySelectorAll('.tab-container .dis-standard-*').forEach(tab => {
                tab.style.display = 'none';
            });

            // Mostrar el elemento correspondiente al número encontrado
            const targetTab = document.querySelector(`.tab-container .dis-standard-${number}`);
            if (targetTab) {
                targetTab.style.display = '';
            }
        }
    });
});

}

*/

function switchProductPdp(element) {
    // Prevenir el comportamiento por defecto del enlace (evitar recargar la página)
    event.preventDefault();

    // Obtener la URL del href del enlace
    const url = element.getAttribute('href');

    // Obtener el contenido de la URL usando fetch
    fetch(url)
        .then(response => response.text()) // Convertir la respuesta a texto (HTML)
        .then(html => {
            // Crear un elemento temporal para parsear el HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Buscar el contenido de la clase específica en el nuevo HTML
            const newContent = doc.querySelector('.t4s-container.t4s-main-product__content.is--layout_default');

            // Si se encuentra el contenido, reemplazar el contenido actual
            if (newContent) {
                const currentContent = document.querySelector('.t4s-container.t4s-main-product__content.is--layout_default');
                currentContent.innerHTML = newContent.innerHTML;

                // Actualizar la URL en la barra de direcciones sin recargar la página
                history.pushState(null, '', url);

                // Llamada a la función que actualiza aspectos del producto (según tu código)
                //switchSwatchPdp();

                // Cargar dinámicamente el archivo interactable.min.js
                const script = document.createElement('script');
                // La siguiente línea usa la URL generada por el asset helper en tu plantilla (Liquid)
                script.src = "https://vitasei.com/cdn/shop/t/26/assets/theme.min.js?v=165489167466526679471740414022";
                // Si necesitas ejecutar código que depende de este script, espera a que se cargue
                script.onload = function() {
                    console.log('El script interactable.min.js se ha cargado y ejecutado.');
                    // Aquí puedes agregar llamadas a funciones definidas en interactable.min.js, si es necesario
                };
                document.head.appendChild(script);
            } else {
                console.error('No se encontró el contenido con las clases especificadas.');
            }
        })
        .catch(error => {
            console.error('Error al cargar el contenido:', error);
        });
}

